import React from "react";

const ANIMALS = [
  "Alligator",
  "Bear",
  "Cat",
  "Dolphin",
  "Eagle",
  "Fox",
  "Giraffe",
  "Hedgehog",
  "Iguana",
  "Jaguar",
  "Koala",
  "Llama",
  "Monkey",
  "Narwhal",
  "Otter",
  "Panda",
  "Quokka",
  "Rabbit",
  "Seal",
  "Tiger",
  "Urial",
  "Vulture",
  "Wolf",
  "Xerus",
  "Yak",
  "Zebra",
];

export function getAnimalFromId(id) {
  const hash = Array.from(String(id)).reduce(
    (acc, ch) => acc + ch.charCodeAt(0),
    0
  );
  return ANIMALS[hash % ANIMALS.length];
}

export function getNicknameFromId(id) {
  return `Anonymous ${getAnimalFromId(id)}`;
}

// Helper: Get animal from player object, preferring stored assignedAnimal
export function getAnimalFromPlayer(player) {
  if (!player) return null;
  return player.get?.("assignedAnimal") || getAnimalFromId(player.id);
}

// Helper: Get nickname from player object, preferring stored nickname
export function getNicknameFromPlayer(player) {
  if (!player) return null;
  return player.get?.("nickname") || getNicknameFromId(player.id);
}

const ANIMAL_TO_EMOJI = {
  Alligator: "🐊",
  Bear: "🐻",
  Cat: "🐱",
  Dolphin: "🐬",
  Eagle: "🦅",
  Fox: "🦊",
  Giraffe: "🦒",
  Hedgehog: "🦔",
  Iguana: "🦎",
  Jaguar: "🐆",
  Koala: "🐨",
  Llama: "🦙",
  Monkey: "🐵",
  Narwhal: "🐳",
  Otter: "🦦",
  Panda: "🐼",
  Quokka: "🐿️",
  Rabbit: "🐰",
  Seal: "🦭",
  Tiger: "🐯",
  Urial: "🐏",
  Vulture: "🦅",
  Wolf: "🐺",
  Xerus: "🐿️",
  Yak: "🐂",
  Zebra: "🦓",
};

export function getAnimalEmoji(animal) {
  return ANIMAL_TO_EMOJI[animal] || "🙂";
}

export function Avatar({ player, showName = true }) {
  // Use stored assigned animal/nickname if available, otherwise fallback to ID-based computation
  const animal = getAnimalFromPlayer(player);
  const nickname = getNicknameFromPlayer(player);
  const emoji = getAnimalEmoji(animal);
  
  return (
    <div className="flex items-center gap-2">
      <div className="h-11 w-11 rounded-full shadow bg-white flex items-center justify-center text-2xl">
        <span aria-hidden>{emoji}</span>
      </div>
      {showName && (
        <div className="text-sm font-semibold text-gray-700 leading-tight">
          {nickname}
        </div>
      )}
    </div>
  );
}
